"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "@/components/ui/CardImage";
import Link from "@/components/ui/Link";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
import PlayButton from "../ui/playbutton";
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  title?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  heightClass?: string;
  /** Mark as LCP image - preloads for faster rendering */
  priority?: boolean;
  imageMetadata?: ImageMetadata;
};
export default function VerticalGradientWithPlaybutton(t0) {
  const $ = _c(26);
  const {
    title: t1,
    imageSrc: t2,
    slug,
    heightClass: t3,
    priority: t4,
    imageMetadata
  } = t0;
  let t5;
  if ($[0] !== t1) {
    t5 = t1 === undefined ? {
      hidden: false,
      value: "\u0BAE\u0BA4\u0BC1\u0BB0\u0BC8 \u0BAE\u0BC0\u0BA9\u0BBE\u0B9F\u0BCD\u0B9A\u0BBF \u0B9A\u0BC1\u0BA8\u0BCD\u0BA4\u0BB0\u0BC7\u0BB8\u0BCD\u0BB5\u0BB0\u0BB0\u0BCD \u0BA4\u0BBF\u0BB0\u0BC1\u0B95\u0BCD\u0B95\u0BB2\u0BCD\u0BAF\u0BBE\u0BA3 \u0BAE\u0B95\u0BCB\u0BB1\u0BCD\u0B9A\u0BB5\u0BAE\u0BCD",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const title = t5;
  let t6;
  if ($[2] !== t2) {
    t6 = t2 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const imageSrc = t6;
  const heightClass = t3 === undefined ? "h-[500px]" : t3;
  const priority = t4 === undefined ? false : t4;
  const titleValue = title?.value || "";
  let t7;
  if ($[4] !== imageSrc?.value) {
    t7 = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
    $[4] = imageSrc?.value;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const imageSrcValue = t7;
  const t8 = `relative w-full ${heightClass} overflow-hidden`;
  let t9;
  if ($[6] !== imageMetadata || $[7] !== imageSrc?.customClass || $[8] !== imageSrc?.hidden || $[9] !== imageSrcValue || $[10] !== priority || $[11] !== titleValue) {
    t9 = !imageSrc?.hidden && <div className="absolute inset-0 w-full h-full"><Image src={imageSrcValue} alt={titleValue} fill={true} priority={priority} sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 500px" className={`object-cover w-full h-full ${imageSrc?.customClass || ""}`} style={getFocusPointStyle(imageMetadata)} loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "auto"} placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div>;
    $[6] = imageMetadata;
    $[7] = imageSrc?.customClass;
    $[8] = imageSrc?.hidden;
    $[9] = imageSrcValue;
    $[10] = priority;
    $[11] = titleValue;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== title?.customClass || $[14] !== title?.hidden || $[15] !== titleValue) {
    t10 = !title?.hidden && <h3 className={`absolute bottom-4 left-4 right-4 text-FFFFFF text-16-tamil-600 md:text-12-tamil-600 ${title?.customClass || ""}`}>{titleValue}</h3>;
    $[13] = title?.customClass;
    $[14] = title?.hidden;
    $[15] = titleValue;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10) {
    t11 = <div className="absolute bottom-0 left-0 right-0 h-2/3 bg-gradient-to-t from-[#0D093E] to-transparent">{t10}</div>;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t8 || $[21] !== t9) {
    t12 = <div className={t8}>{t9}{t11}</div>;
    $[19] = t11;
    $[20] = t8;
    $[21] = t9;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const content = t12;
  if (slug) {
    const t13 = `/${slug}`;
    let t14;
    if ($[23] !== content || $[24] !== t13) {
      t14 = <Link href={t13} className="block hover:opacity-90 transition-opacity cursor-pointer">{content}</Link>;
      $[23] = content;
      $[24] = t13;
      $[25] = t14;
    } else {
      t14 = $[25];
    }
    return t14;
  }
  return content;
}